import Modal from 'honeydew/Modal';

export const LEGAL_COPY =
    'Estimated per-pound price is calculated using the average packed weight for this item based on recent fulfillment data. Actual weight varies.';

/**
 * Price per unit legal modal component
 * stopPropagation onClick is to prevent the modal from redirecting the user to the PDP
 * when clicking in the modal itself due to its nested nature when used on the product card
 *
 * @param {Object} props Component props
 * @param {Function} props.onClose Callback function to close the modal
 * @param {boolean} props.open Whether the modal is open
 * @returns
 */
function PricePerUnitLegalModal({ onClose, open }) {
    return (
        <Modal open={open} onClose={onClose} onClick={(e) => e.stopPropagation()}>
            <section className="mx-auto max-w-[584px] pb-30">
                <h1 className="text-heading-md">How is this calculated?</h1>
                <p className="text-body-sm mt-40 text-grey">{LEGAL_COPY}</p>
            </section>
        </Modal>
    );
}

export default PricePerUnitLegalModal;
